import styled from 'styled-components';
import { Table, Form } from 'react-bootstrap';
import { ToReadableDate, ToCurrencyFormat } from '../../../utils';
import { useRef } from 'react';
import { PaginationComponent } from '../claim-review';
import Swal from 'sweetalert2';

const SubDescription = styled.div`
    font-size: 15px;
    font-weight: 300;
    padding: 5px 0px;
`;

const TableContainer = styled.div`
    overflow-x: auto;
    white-space: nowrap;
    padding: 0;
    margin: 0;
    width: 100%;
`;

const InfoContainer = styled.div`
    position: relative;
    display: inline-block;
    cursor: pointer;

    &:hover .info-description {
        display: block;
    }
`;

const StyledDescription = styled.p`
    font-style: italic;
    font-size: 12px;
    color: black;
    display: none;
    position: absolute;
    background: rgba(255, 255, 255, 1);
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 430px;
    z-index: 100;
    top: -45px;
    left: -220px;
    font-weight: 500;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 250px;
        left: -67px;
        top: -60px;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;

    @media (min-width: 300px) and (max-width: 500px) {
        justify-content: center;
    }
`;

export default function ShowPolicyView({
    formData,
    setFormData,
    setLoading,
    bindAvailableClaims,
    docPerClaimTypes,
    policyTablePageChange
}) {
    const policyCheckboxesRef = useRef({});

    const processRef = (element, id) => {
        if (element) {
            policyCheckboxesRef.current[id] = element;
            if (formData.selectedPolicy === id) {
                policyCheckboxesRef.current[id].checked = true;
            }
        }
    };

    const handlePolicySelection = async (e, event) => {
        if (event.id === formData.selectedPolicy) {
            e.preventDefault();
            return;
        }

        setLoading(true);
        const claims = await bindAvailableClaims(event.id);
        console.log('claims: ', claims);
        setLoading(false);

        if (formData?.selectedPolicy !== event.id) {
            const { customerDetails, ...policyCustomerDetails } = formData.availablePolicy.find(
                (item) => item.id === event.id
            );

            setFormData({
                ...formData,
                selectedPolicy: event.id,
                availableClaims: claims.claims,
                availableClaimsPagination: {
                    totalData: claims.totalData,
                    totalPage: claims.totalPage,
                    currentPage: claims.currentPage
                },
                createNewClaim: false,
                selectedClaim: claims.claims.length ? undefined : 'create new claim',
                claimsPayload: {
                    refId: event.id,
                    refTable: 'txn_uploaded_policy',
                    status: 'Pending',
                    customerDetails: {
                        ...customerDetails,
                        ...policyCustomerDetails
                    }
                },
                docPerClaimTypes: docPerClaimTypes
            });

            Object.keys(policyCheckboxesRef.current).forEach((key) => {
                if (key !== event.id.toString()) {
                    policyCheckboxesRef.current[key].checked = false;
                } else {
                    policyCheckboxesRef.current[key].checked = true;
                }
            });
        }
    };

    const pageChange = async (page) => {
        try {
            setLoading(true);
            const callPolicyTablePageChange = await policyTablePageChange(page);

            Object.keys(policyCheckboxesRef.current).forEach((key) => {
                policyCheckboxesRef.current[key].checked = false;
            });

            const setPayload = {
                ...formData,
                availablePolicy: callPolicyTablePageChange.data.uploadedPolicies,
                availablePolicyPagination: {
                    totalData: callPolicyTablePageChange.data.totalData,
                    totalPage: callPolicyTablePageChange.data.totalPage,
                    currentPage: callPolicyTablePageChange.data.currentPage
                },
                selectedClaim: undefined,
                availableClaims: [],
                availableClaimsPagination: {}
            };
            setFormData(setPayload);
            console.log('new policy data on page change: ', setPayload);

            setLoading(false);
        } catch (error) {
            console.error('error occured: ', error);
            Swal.fire({
                text: 'Something went wrong. Please try again later.',
                icon: 'error',
                iconColor: 'black',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
            setLoading(false);
        }
    };

    return (
        <div>
            <SubDescription>
                {/* <i className="bi bi-info-circle" style={{ padding: '2px', fontSize: '14px' }}></i> */}
                Please select the applicable policy based on the date of your claims incident.
                <InfoContainer>
                    <i className="bi bi-info-circle" style={{ padding: '2px', fontSize: '16px' }}></i>
                    <StyledDescription className="info-description">
                        For more information please go to{' '}
                        <a href="https://bit.ly/BPIMS_HPC_FAQs" target="_blank">
                            https://bit.ly/BPIMS_HPC_FAQs
                        </a>
                        .
                    </StyledDescription>
                </InfoContainer>
            </SubDescription>
            <TableContainer>
                <Table striped bordered hover>
                    <thead className="text-center">
                        <tr>
                            <th width="2%"></th>
                            <th>Loan Account Number</th>
                            <th>Effective Date</th>
                            <th>Expiry Date</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {formData?.availablePolicy &&
                            formData.availablePolicy.map((item, index) => {
                                return (
                                    <tr key={'policyItem_' + index}>
                                        <td className="text-center">
                                            {formData.availablePolicy.length === 1 ? (
                                                <Form.Check
                                                    className="checkbox"
                                                    style={{ margin: '3px 5px 0px 7px' }}
                                                    type="checkbox"
                                                    name="agreed"
                                                    defaultChecked
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                ></Form.Check>
                                            ) : (
                                                <Form.Check
                                                    className="checkbox"
                                                    style={{ margin: '3px 5px 0px 7px' }}
                                                    type="checkbox"
                                                    name="agreed"
                                                    ref={(el) => processRef(el, item.id)}
                                                    onClick={(e) => handlePolicySelection(e, item)}
                                                ></Form.Check>
                                            )}
                                        </td>
                                        <td>{item.coicNo}</td>
                                        <td>{ToReadableDate(item.inceptionDate)}</td>
                                        <td>{ToReadableDate(item.expiryDate)}</td>
                                    </tr>
                                );
                            })}
                        {!formData?.availablePolicy && (
                            <tr className="text-center">
                                <td colSpan="4">No policy available.</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </TableContainer>

            {formData?.availablePolicyPagination?.totalData > 5 && (
                <ButtonContainer>
                    <PaginationComponent
                        totalPage={formData?.availablePolicyPagination?.totalPage}
                        currentPage={formData?.availablePolicyPagination?.currentPage}
                        onPageChange={pageChange}
                    />
                </ButtonContainer>
            )}
        </div>
    );
}
